import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Country {
  id: number;
  name: string;
  code: string | null;
}

export interface SignupLeadPayload {
  name: string;
  email: string;
  phone: string;
  company_name: string;
  country: string;
  service_type: string;

  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
}

export interface SignupLeadResponse {
  success: boolean;
  message: string;
  id: number;
}


@Injectable({
  providedIn: 'root'
})
export class LeadsSignupServiceService {

 
  private readonly signupLeadUrl =
    `${environment.baseUrl}/email-leads/signupLead`;

  private readonly countriesUrl =
    `${environment.baseUrl}/locations/countries`;

  constructor(private http: HttpClient) {}

  createSignupLead(
    data: SignupLeadPayload
  ): Observable<SignupLeadResponse> {

    return this.http.post<SignupLeadResponse>(
      this.signupLeadUrl,
      data
    );
  }

  getCountries(): Observable<Country[]> {

    return this.http.get<Country[]>(
      this.countriesUrl
    );
  }
}